import axios from "axios";
import { getField, updateField } from "vuex-map-fields";
import i18n from "@/i18n";
import Vue from "vue";

export default {
  namespaced: true,
  state: {
    time: false,
    fetched: false,
    suppliersNames: [],
    suppliersFromAPI: [],
    suppliers: [],
    supplier: null,
    nowProcessingSupplierWithId: null,
    find_string: null,
    brands: {
      loader: false,
      part_number: null,
      parts: [],
      stats: [],
    },
    parts: {
      loader: false,
      data: {
        pricelists: [],
        //concatenated: [],
        requested_parts: [],
        replica: [],
        parts_component: [],
        related_parts: [],
      },
      stats: null,
    },
  },
  getters: {
    getField, //vuex-map-fields
  },
  mutations: {
    addOneSupplierToState(state, data) {
      let object = state.suppliers;
      object.unshift(data);
      updateField(state, { path: "suppliers", value: object });
    },
    updateField, //vuex-map-fields
    updateBrandsParts(state, parts) {

      let items = [];
      let clear = (str)=>{
        if(!str) return str;
        return str.replace(/[\. ,&:-]+/g, "");
      }
      parts.forEach((item)=>{
        if (!(items.find(e => clear(e.brand) === clear(item.brand) && clear(e.part_code) === clear(item.part_code)))) {
          items.push(item);
        }
      })
      if(items.length>0){ //заполним name и image_url
        for(let i in items){
          if(!items[i].name || items[i].name === ''){
            parts.forEach((part)=>{
              if(clear(part.brand) === clear(items[i].brand) && clear(part.part_code) === clear(items[i].part_code) && part.name && part.name!==''){
                items[i].name = part.name;
              }
            })
          }
          if(!items[i].image_url || items[i].image_url === ''){
            parts.forEach((part)=>{
              if(clear(part.brand) === clear(items[i].brand) && clear(part.part_code) === clear(items[i].part_code) && part.image_url && part.image_url!==''){
                items[i].image_url = part.image_url;
              }
            })
          }
        }
      }
      state.brands.parts = items;
    },
    updateBrandsStats(state, stats) {
      state.brands.stats = stats;
    },
    updateBrandsLoader(state, status) {
      state.brands.loader = status;
    },
    updatePartsLoader(state, status) {
      state.parts.loader = status;
    },
    clearPartsData(state) {
      state.parts.stats = null;
      state.parts.data = {
        //concatenated: [],
        requested_parts: [],
        pricelists: [],
        replica: [],
        parts_component: [],
        related_parts: [],
      };
    },
    updatePartsData(state, data) {
      state.parts.data = data;
    },
    updatePartsStats(state, stats) {
      state.parts.stats = stats;
    },
    updateSuppliersNames(state, data) {
      let obj = {};
      data.forEach((one) => {
        obj[one["supplier"]] = one["full_name"];
      });
      Vue.set(state, "suppliersNames", obj);
    },
    updateSuppliersFromAPI(state, data) {
      data.forEach((val, index) => {
        if (data[index]["nowSave"] !== true) {
          data[index]["nowSave"] = false;
        }
      });
      Vue.set(state, "suppliersFromAPI", data);
    },
    removeSupplierFromState(state, id) {
      let data = [];
      Object.entries(state.suppliers).forEach((item) => {
        if (Number(item[1].id) != Number(id)) {
          data.push(item[1]);
        }
      });
      updateField(state, { path: "fetched", value: true });
      //Clone the array to trigger a UI update
      state.suppliers = [...data];
    },
    updateSupplierInState(state, data) {
      let existsAtIndex = state.suppliers.findIndex((u) => u.id === data.id);
      if (existsAtIndex !== -1) {
        state.suppliers[existsAtIndex] = data;
      }
      //Clone the array to trigger a UI update
      state.suppliers = [...state.suppliers];
    },
  },
  actions: {
    async get({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(this._vm.$apiURL + `/suppliers`, {
          params: {
            find_string: state.find_string,
          },
        })
        .then((response) => {
          updateField(state, { path: "fetched", value: true });
          updateField(state, { path: "suppliers", value: response.data });
        })
        .catch((error) => {
          updateField(state, { path: "fetched", value: true });
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async getSupplier({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(this._vm.$apiURL + `/suppliers/${payload}`, {
          params: {
            find_string: state.find_string,
          },
        })
        .then((response) => {
          updateField(state, { path: "fetched", value: true });
          updateField(state, {
            path: "supplier",
            value: response.data.supplier,
          });
        })
        .catch((error) => {
          updateField(state, { path: "fetched", value: true });
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    async store({ commit, state, dispatch }, payload) {
      updateField(state, { path: "nowProcessingSupplierWithId", value: "new" });
      return await axios
        .post(this._vm.$apiURL + "/suppliers", payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.success_add"));
          if (response.data.id) {
            commit("addOneSupplierToState", response.data.new);
          }
          return response.data.new;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, {
            path: "nowProcessingSupplierWithId",
            value: null,
          });
        });
    },
    async update({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .put(this._vm.$apiURL + "/suppliers/" + payload.id, payload)
        .then((response) => {
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
          commit("updateSupplierInState", response.data.updated);
          return response.data.updated;
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async remove({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      return await axios
        .delete(this._vm.$apiURL + "/suppliers/" + payload, {
          id: payload,
        })
        .then((response) => {
          if (response.data.status === "success") {
            commit("removeSupplierFromState", payload);
            this._vm.$inform(this._vm.i18n.t("common.success_remove"));
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    checkSupplierAPIConfig({ commit, state, dispatch }, payload) {
      //supplier-check-config
      let config = {};
      let tmpSuppliersState = state.suppliersFromAPI;
      for (let i in tmpSuppliersState) {
        if (tmpSuppliersState[i].supplier === payload.supplier) {
          config = state.suppliersFromAPI[i].config;
          tmpSuppliersState[i].nowSave = true;
        }
      }
      commit("updateSuppliersFromAPI", tmpSuppliersState);

      axios
        .post(this._vm.$apiURL + "/suppliers-api/check-config", {
          supplier: payload.supplier,
          config: config,
        })
        .then((response) => {
          if (response.data.data.success) {
            this._vm.$inform(
              this._vm.i18n.t("viewSuppliersSettings.setting_is_correct")
            );
          } else {
            throw (
              (response.data &&
                response.data.data &&
                response.data.data.message) ||
              "Unknown Error"
            );
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          for (let i in tmpSuppliersState) {
            if (tmpSuppliersState[i].supplier === payload.supplier) {
              config = state.suppliersFromAPI[i].config;
              tmpSuppliersState[i].nowSave = false;
            }
          }
          commit("updateSuppliersFromAPI", tmpSuppliersState);
        });
    },
    async saveSupplierAPIConfig({ commit, state, dispatch }, payload) {
      updateField(state, { path: "fetched", value: false });
      let config = {};
      let tmpSuppliersState = state.suppliersFromAPI;
      for (let i in tmpSuppliersState) {
        if (tmpSuppliersState[i].supplier === payload.supplier) {
          config = state.suppliersFromAPI[i].config;
          tmpSuppliersState[i].nowSave = true;
        }
      }
      commit("updateSuppliersFromAPI", tmpSuppliersState);

      return await axios
        .post(this._vm.$apiURL + "/suppliers-api", {
          supplier: payload.supplier,
          config: config,
        })
        .then((response) => {
          return true;
          this._vm.$inform(this._vm.i18n.t("common.operation_success"));
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          for (let i in tmpSuppliersState) {
            if (tmpSuppliersState[i].supplier === payload.supplier) {
              config = state.suppliersFromAPI[i].config;
              tmpSuppliersState[i].nowSave = false;
            }
          }
          commit("updateSuppliersFromAPI", tmpSuppliersState);
          updateField(state, { path: "fetched", value: true });
        });
    },
    async getSuppliersByAPIWithConfig({ commit, state, dispatch }) {
      //список поставщиков с настройками
      updateField(state, { path: "fetched", value: false });
      return await axios
        .get(this._vm.$apiURL + "/suppliers-by-api")
        .then((response) => {
          //this.response_debug = response;
          if (response.data.error) {
            throw response.data.error || "unknown API Suppliers error";
          } else {
            commit("updateSuppliersFromAPI", response.data || []);
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          updateField(state, { path: "fetched", value: true });
        });
    },
    async getSuppliersListByAPI({ commit, state, dispatch }) {
      //названия поставщиков
      if (Object.keys(state.suppliersNames).length !== 0) return;
      return await axios
        .get(this._vm.$apiURL + "/suppliers-api/list")
        .then((response) => {
          this.response_debug = response;
          if (response.data.error) {
            if (error.response.data.errors) {
              this._vm.$error(
                Object.entries(error.response.data.errors)[0][1][0]
              );
            } else {
              this._vm.$error(error.response.statusText);
            }
          } else {
            commit("updateSuppliersNames", response.data || []);
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        });
    },
    brandsGet({ commit, state, dispatch }, payload) {
      commit("updateBrandsLoader", true);
      commit("clearPartsData");
      commit("updatePartsStats", null);
      axios
        .post(this._vm.$apiURL + "/suppliers/api", {
          method: "brands",
          data: {
            part_code: state.brands.part_number,
            with_nomenclature: payload.with_nomenclature,
            with_goods: payload.with_goods
          },
        })
        .then((response) => {
          if (response.data.error) {
            if (error.response.data.errors) {
              this._vm.$error(
                Object.entries(error.response.data.errors)[0][1][0]
              );
            } else {
              this._vm.$error(error.response.statusText);
            }
          } else {
            commit("updateBrandsParts", response.data.parts || []);
            commit("updateBrandsStats", response.data.stats || []);
            //state.stats = response.data.parts
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
        })
        .finally(() => {
          state.loaderBrandsGet = false;
          commit("updateBrandsLoader", false);
        });
    },
    partsGet({ commit, state, dispatch }, payload) {
      commit("updatePartsLoader", true);
      axios
        .post(this._vm.$apiURL + "/suppliers/api", {
          method: "parts",
          data: { part_code: payload.part_code, brand: payload.brand },
        })
        .then((response) => {
          if (response.data.error) {
            if (error.response.data.errors) {
              this._vm.$error(
                Object.entries(error.response.data.errors)[0][1][0]
              );
            } else {
              this._vm.$error(error.response.statusText);
            }
          } else {
            commit("updatePartsData", response.data.data || []);
            commit("updatePartsStats", response.data.stats || null);
          }
        })
        .catch((error) => {
          dispatch("common/showError", { error: error }, { root: true });
          state.loaderBrandsGet = false;
        })
        .finally(() => {
          commit("updatePartsLoader", false);
        });
    },
  },
};
